<template>
    <div class="checkpoint-status-card">
        <div class="checkpoint-header-container">
            <span class="checkpoint-name">{{ checkpointName }}</span>
        </div>

        <div class="checkpoint-status-container d-flex gap-2">
            <div class="d-flex flex-column mt-2 gap-4" style="flex: 1">
                <LaneOverview :areas="areas" />

                <div class="asset-graph-wrapper gap-2">
                    <asset-status-bar-chart :operable="operableCount" :inoperable="inoperableCount" class="status-bar-chart" />

                    <div class="d-flex gap-2 overflow-x-auto">
                        <doughnut-chart-card
                            v-for="item in metricsWithInoperableItems"
                            :key="item.name"
                            :values="[item.inoperable, item.operable]"
                            :center-label="item.inoperable"
                            :label="item.name"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import AssetStatusBarChart from '@/Pages/DashboardV2/Components/CriticalLocations/AssetStatusBarChart.vue';
import LaneOverview from '@/Pages/DashboardV2/Components/LaneOverview.vue';
import DoughnutChartCard from '@/Components/Charts/DoughnutChartCard.vue';
import { computed } from 'vue';

const props = defineProps({
    checkpointName: { type: String, default: '' },
    areas: {
        type: Array,
        default: () => [],
    },
    metrics: {
        type: Array,
        default: () => [],
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

const metricsWithInoperableItems = computed(() => {
    return props.metrics.filter((metric) => metric.inoperable > 0);
});

const operableCount = computed(() => props.metrics.reduce((sum, metric) => sum + metric.operable, 0));

const inoperableCount = computed(() => props.metrics.reduce((sum, metric) => sum + metric.inoperable, 0));
</script>

<style scoped>
.status-bar-chart {
    flex: none;
    margin-right: 32px;
}

.circular-graph.not-first {
    margin-left: 10px;
}

.circular-graph {
    flex: none;
}

.asset-graph-wrapper {
    display: flex;
    align-items: flex-start;
    margin-left: 16px;
}

.circular-graphs-container {
    display: flex;
    overflow-x: auto;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 8px;
    flex: 1;
}

/* Add custom scrollbar styling */
.circular-graphs-container::-webkit-scrollbar {
    height: 6px;
}

.circular-graphs-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.circular-graphs-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

.circular-graphs-container::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.checkpoint-name {
    color: var(--Warm-Grey, #525252);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    /* 100% */
    margin-right: 12px;
}

.checkpoint-issues-count {
    display: inline-flex;
    padding: 6px 12px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    border: 1px solid var(--Light-Grey, #e4e5e6);
    color: var(--Body-Grey, #777);
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}

.checkpoint-status-card {
    width: 409px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex-shrink: 0;
    border-radius: 12px;
    border: 1px solid var(--Light-Grey, #e4e5e6);
    background: var(--White, #fff);
    padding: 16px 8px;
}

.checkpoint-header-container {
    padding-bottom: 6px;
}
</style>
